import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()({
  search: {
    marginTop: 16,
    marginBottom: 30,
    width: 540,
  },
  addButton: {
    marginTop: 8,
    color: '#ffffff',
  },
  dropdown: {
    color: '#000000 !important',
    '& .MuiSelect-select': {
      color: '#000000 !important',
    },
    '& .MuiSelect-icon': {
      color: '#000000 !important',
    },
  },
  dropdownOption: {
    color: '#000000 !important',
  },
  vehicleInputContainer: {
    position: 'relative',
    zIndex: 20,
  },
  vehicleOptions: {
    position: 'absolute',
    bottom: '100%',
    left: 0,
    zIndex: 20,
    maxHeight: 180,
    overflowY: 'auto',
    backgroundColor: '#ffffff',
  },
  vehicleOption: {
    color: '#000000',
    padding: '6px 10px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#eeeeee',
    },
  },
});
